import getUrl, {APP_KEY} from 'airship/modules/get-url'
import createRequest from 'airship/modules/typesafe-request'
import {
  arrayResolver,
  noopResolver,
  objectResolver,
  resolveString,
} from 'airship/utils/resolvers'

import type {ReviewUser, UserProfile} from './types'
import {
  resolvePartialUserProfile,
  resolveReviewUsers,
  resolveUserProfile,
} from './types'

const GROUPS_URL = 'users:groups'

export async function fetchUserProfile(): Promise<UserProfile> {
  const path: string = getUrl('users:info')
  const request = createRequest({path})
  const response = await request.get(resolveUserProfile)
  return response.body
}

export async function updateUserProfile(
  body: Partial<UserProfile>
): Promise<Partial<UserProfile>> {
  const path: string = getUrl('users:info')
  const request = createRequest({path})
  const response = await request.put(resolvePartialUserProfile, {body})
  return response.body
}

export async function fetchReviewers(): Promise<ReviewUser[]> {
  const path = getUrl('approval_workflow:reviewers', {key: APP_KEY})
  const request = createRequest({path})
  const response = await request.get(resolveReviewUsers)
  return response.body.objects
}

export async function getGroups(): Promise<string[]> {
  const path = getUrl(GROUPS_URL)
  const request = createRequest({path})
  const response = await request.get(
    objectResolver({groups: arrayResolver(resolveString)})
  )
  return response.body.groups
}

type EditGroupData = {action: 'add' | 'remove'; group: string}
export async function editGroup(data: EditGroupData): Promise<void> {
  const path = getUrl(GROUPS_URL)
  const request = createRequest({path})
  await request.post(noopResolver, {
    body: data,
  })
}
